import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  @media (orientation: portrait) {
    grid-template-columns: 1fr;
  }
`

const Map = styled.div`
  height: calc(100vh - 64px);
  position: relative;
  z-index: 2;
  @media (orientation: portrait) {
    height: 30vh;
  }
`

const ColMap = styled.div`
  grid-column: span 2;
  @media (orientation: portrait) {
    grid-column: span 1;
    left: 0;
    right: 0;
    bottom: 0;
    top: 64px;
    position: sticky;
    z-index: 30;
  }
`

const WrapperMap = styled.div`
  position: sticky;
  left: 0;
  right: 0;
  bottom: 0;
  top: 64px;
  @media (orientation: portrait) {
    position: sticky;
    bottom: auto;
  }
`

const WrapperScroller = styled.div`
  position: relative;
  z-index: 2;
  box-shadow: 0 0 20px rgb(0 0 0 / 30%);
  /* pointer-events: none; */
`

export { Wrapper, Map, WrapperMap, WrapperScroller, ColMap }
